export default __webpack_public_path__ + "static/media/aamay24.bcfa6dc8.ttf";